var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-bar-container"},[_c('div',{staticClass:"loading-bar"},[_c('div',{staticClass:"loading-progress",style:({ width: _vm.displayedPercentage + '%' })}),_c('span',{staticClass:"loading-text"},[_vm._v(" Returning answer.. "+_vm._s(_vm.displayedPercentage.toFixed(0))+"% ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }